import React, { createContext, useContext, useState, useEffect } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { lightTheme, darkTheme } from "../theme";
const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

export const CustomThemeProvider = ({ children }) => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: light)");

  // Retrieve the theme from localStorage or fallback to system preference
  const getInitialTheme = () => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      return storedTheme === "dark"; // true if dark, false if light
    }
    return prefersDarkMode; // Fallback to system preference if no stored theme
  };

  const [isDarkMode, setIsDarkMode] = useState(getInitialTheme);

  // Save the theme to localStorage whenever it's toggled
  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem("theme", newMode ? "dark" : "light");
  };

  // Apply the chosen theme
  const theme = isDarkMode ? darkTheme : lightTheme;

  useEffect(() => {
    // Update localStorage whenever the theme changes
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
